module.exports = "/images/trial-proofs-icon.svg?c46e8ba24ba0754afa04687ed48ac33f";